export default __webpack_public_path__ + "static/media/covers.87dbe99e.svg";